import { render, staticRenderFns } from "./ConfirmInvitation.vue?vue&type=template&id=1bb9f1ed&scoped=true&"
import script from "./ConfirmInvitation.vue?vue&type=script&lang=ts&"
export * from "./ConfirmInvitation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb9f1ed",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bb9f1ed')) {
      api.createRecord('1bb9f1ed', component.options)
    } else {
      api.reload('1bb9f1ed', component.options)
    }
    module.hot.accept("./ConfirmInvitation.vue?vue&type=template&id=1bb9f1ed&scoped=true&", function () {
      api.rerender('1bb9f1ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/auth/ConfirmInvitation.vue"
export default component.exports